import { modelT } from "../../redux/features/ui/ui.types";

export const modelsBedroom: modelT[] = [
  {
    img: "/images/assets/ClassicSofa/ArmChair.png",
    label: "Twin",
    labelUI: "Twin",
    description: "Compact fit",
    nameValueThreekit: "Twin",
    configurationShortId: "kW8RqoLBc",
    subcategory: "Rails",
  },
  {
    img: "/images/assets/ClassicSofa/ArmChair.png",
    label: "Full",
    labelUI: "Full",
    description: "Just right size",
    nameValueThreekit: "Full",
    configurationShortId: "KnaeXYML2",
    subcategory: "Rails",
  },
  {
    img: "/images/assets/ClassicSofa/ArmChair.png",
    label: "Queen",
    labelUI: "Queen",
    description: "Everyday favorite",
    nameValueThreekit: "Queen",
    configurationShortId: "qxn08MO-p",
    subcategory: "Rails",
  },
  {
    img: "/images/assets/ClassicSofa/ArmChair.png",
    label: "California King",
    labelUI: "California King",
    description: "Spacious luxury",
    nameValueThreekit: "California King",
    configurationShortId: "DaxuPydgN",
    subcategory: "Rails",
  },
  {
    img: "/images/assets/ClassicSofa/ArmChair.png",
    label: "Eastern King",
    labelUI: "Eastern King",
    description: "Wide comfort",
    nameValueThreekit: "Eastern King",
    configurationShortId: "k-3yVT9zf",
    subcategory: "Rails",
  },
];
